<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    v-model="model.nome"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-select
                    :options="form.unidadesMedida"
                    :validations="validations.unidadeMedida"
                    label="Unidade de medida"
                    text-field="nome"
                    v-model="model.unidadeMedidaId"
                    value-field="id"
                    show-default-option
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :options="form.formasFarmaceutica"
                    :validations="validations.formaFarmaceutica"
                    label="Forma farmacêutica"
                    show-default-option
                    text-field="nome"
                    v-model="model.formaFarmaceuticaId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-select
                    :options="form.viasAdministracao"
                    :validations="validations.viaAdministracao"
                    label="Via de administração"
                    show-default-option
                    text-field="nome"
                    v-model="model.viaAdministracaoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-select
                    :options="form.tiposReceita"
                    :validations="validations.receitaTipo"
                    label="Receita"
                    show-default-option
                    text-field="nome"
                    v-model="model.receitaTipoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="12">
                <rkm-form-checkbox
                    v-model="model.exibirReceita"
                    inline
                    :checked="modelReceitaMedica"
                    :disabled="modelReceitaMedica"
                >
                    Exibir na receita médica
                </rkm-form-checkbox>

                 <rkm-form-checkbox
                    v-model="model.exibirPrescricaoInterna"
                    inline
                    v-if="!modelReceitaMedica"
                >
                    Exibir na prescrição interna
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'


export default {
    computed: {
        validations() {

            return {
                nome: { required: true, max: 255 },
                unidadeMedida: { required: true },
                formaFarmaceutica: { required: true },
                viaAdministracao: { required: true },
                receitaTipo: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            medicamento: this.getConectaSusRepository('cadastro.medicamento.medicamento'),
        }

        this.load()
    },
    data: () => ({
        model: {
            exibirReceita: true,
            exibirPrescricaoInterna: true,
        },
        form: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.medicamento.edit(this.id)
                : this.repositories.medicamento.create()

            request
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    if (this.modelReceitaMedica){
                        this.model.exibirReceita = true
                    }
                    if (this.model.exibirReceita === null){
                        this.model.exibirReceita = false
                    }
                    if (this.model.exibirPrescricaoInterna === null){
                        this.model.exibirPrescricaoInterna = false
                    }

                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                     if (this.model.exibirReceita === false && this.model.exibirPrescricaoInterna === false) {
                        this.showValidationNotification(
                            'É obrigatório informar se a exibição será na receita médica e/ou na prescrição interna.'
                        )
                    }
                    else{
                        this.setLoading()

                    const request = this.id
                        ? this.repositories.medicamento.update(this.id, this.prepareData())
                        : this.repositories.medicamento.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                    }
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive(this.clone(this.model))
        },
    },
    mixins: [repository, stringCase, object, error],
    props: {
        id: { type: Number },
        modelReceitaMedica: { type: Boolean, default: false },
    },
}
</script>